import { MeteringReport } from "@/shared/domain/metering";
import { Resource } from "@/types/resources";

import { MeteringVals } from "./types";

function bytes_to_gigabytes(val: number) {
  return val / 1024 / 1024 / 1024;
}

export const parseMeteringData = (
  meteringReportData: MeteringReport | MeteringReport[] | null,
): MeteringVals[] | undefined => {
  if (!meteringReportData) {
    return;
  }

  const mData: MeteringVals[] = [];

  const reports = Array.isArray(meteringReportData)
    ? meteringReportData
    : [meteringReportData];

  for (const report of [...reports].reverse()) {
    const date = new Date(report.end_time);

    const monthYr = date.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    });

    let data_stored_gb = 0;
    let datasets_created = 0;
    let invocations_scheduled = 0;
    let data_egress_bandwidth_gb = 0;
    let data_upload_gb = 0;
    let action_run_time_hrs = 0;
    let action_compute_credits = 0;
    let agent_units = 0;

    for (const resource of report.values) {
      switch (resource.resource_name) {
        case Resource.ManagedDataStoredBytes:
          data_stored_gb = bytes_to_gigabytes(resource.quantity);
          break;
        case Resource.DatasetsCreated:
          datasets_created = resource.quantity;
          break;
        case Resource.InvocationsScheduled:
          invocations_scheduled = resource.quantity;
          break;
        case Resource.ManagedDataDownloadBytes:
          data_egress_bandwidth_gb = bytes_to_gigabytes(resource.quantity);
          break;
        case Resource.ManagedDataUploadBytes:
          data_upload_gb = bytes_to_gigabytes(resource.quantity);
          break;
        case Resource.InvocationRuntimeMillis:
          action_run_time_hrs = resource.quantity / 1000 / 60 / 60;
          break;
        case Resource.InvocationComputeCreditMillionths:
          action_compute_credits = resource.quantity / 1_000_000;
          break;
        case Resource.AiCreditMillionths:
          agent_units = resource.quantity / 1_000_000;
          break;
      }
    }

    mData.push({
      name: monthYr,
      data_stored_gb,
      datasets_created,
      invocations_scheduled,
      data_egress_bandwidth_gb,
      data_upload_gb,
      action_run_time_hrs,
      action_compute_credits,
      agent_units,
    });
  }

  return mData;
};
